import React, { useCallback } from "react";
import { Form } from "react-bootstrap";
import { Controller } from "react-hook-form";

import {
	ErrorMessage,
	RequiredMark,
	SelectAsync,
	UserOptionLabel,
} from "components";
import { DebounceTimeout } from "globalConstants";
import { applicationListService } from "services";
import { required } from "validators";

type PendedToSelectProps = { loading: boolean; control: any; errors: any };

const PendedToSelect = ({
	loading = false,
	control,
	errors,
}: PendedToSelectProps) => {
	const loadPendedTo = useCallback(async (search, prevOptions, { page }) => {
		try {
			let newUsers = await applicationListService.getAssignedUsers?.(
				search,
				page,
			);

			const hasMore =
				prevOptions.length + newUsers.items.length < newUsers.count;

			return {
				options: newUsers.items,
				hasMore,
				additional: {
					page: page + 1,
				},
			};
		} catch {
			return { options: [] };
		}
	}, []);

	return (
		<>
			<Form.Label>
				Pended to
				<RequiredMark />
			</Form.Label>
			<Controller
				control={control}
				render={({ field }) => (
					<SelectAsync
						{...field}
						loading={loading}
						placeholder="Please Select"
						className="select-md"
						cacheOptions
						defaultOptions
						debounceTimeout={DebounceTimeout}
						loadOptions={loadPendedTo}
						getOptionLabel={UserOptionLabel}
						getOptionValue={option => option.id}
						additional={{ page: 0 }}
					/>
				)}
				name="pendedTo"
				rules={{ validate: { required } }}
			/>
			<ErrorMessage field="pendedTo" errors={errors} />
		</>
	);
};

export default PendedToSelect;
